
    class PDPCountdownTimer extends HTMLElement {

    connectedCallback() {
        this.hasEnded = false;
        this.endDate = new Date().getTime();
        console.log(this.endDate)
        if (this.dataset.pdpEndDate) {
            this.endDate = new Date(this.dataset.pdpEndDate).getTime();
        }
        console.log(this.endDate)
        console.log(this.dataset.pdpEndDate)
        this.daysElement = this ? this.querySelector("days") : null;
        this.hoursElement = this ? this.querySelector("hours") : null;
        this.minutesElement = this ? this.querySelector("minutes") : null;
        this.secondsElement = this ? this.querySelector("seconds") : null;
        this.activeContentElement = this
            ? this.querySelector("active-content")
            : null;
        this.endContentElement = this
            ? this.querySelector("ended-content")
            : null;
        if (this.endDate) {
            this.setTimer();
        }
        else {
            console.warn("PDPCountdownTimer Timer needs an end date");
        }
    }
    disconnectedCallback() {
      console.log('Custom element removed from page.');
    }
    showContent() {
        if (this.activeContentElement) {
            this.hasEnded
                ? (this.activeContentElement.style.display = "none")
                : (this.activeContentElement.style.display = "flex");
        }
        if (this.endContentElement) {
            this.hasEnded
                ? (this.endContentElement.style.display = "none")
                : (this.endContentElement.style.display = "none");
        }
    }
    setTimer() {
  
        const timer = () => {
            if (typeof this.endDate != "number")
                return;
            const now = new Date().getTime();
            let diff = this.endDate - now;
            // Showing the alert when timer finishes.

            this.hasEnded = false;
            if (diff < 0) {
                this.hasEnded = true;
                this.style.display = 'none'; // Hide the countdown timer when time has passed
                // Hide the parent element as well
                this.parentElement.style.display = 'none';
                return; // Stop the timer
            }
            this.showContent();
            let days = Math.floor(diff / (1000 * 60 * 60 * 24));
            let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((diff % (1000 * 60)) / 1000);
            this.daysElement
                ? this.updateDigits(this.daysElement, days)
                : false;
            this.hoursElement
                ? this.updateDigits(this.hoursElement, hours)
                : false;
            this.minutesElement
                ? this.updateDigits(this.minutesElement, minutes)
                : false;
            this.secondsElement
                ? this.updateDigits(this.secondsElement, seconds)
                : false;
            this.setDisplay(this.daysElement, days);
            this.setDisplay(this.hoursElement, hours);
            this.setDisplay(this.minutesElement, minutes);
            this.setDisplay(this.secondsElement, seconds, true);
            if (this) {
                this.style.display = 'flex';
            }
        };
        timer();
        // Run function every second.
        setInterval(timer, 1000);
    }
    setDisplay(element, timer, alwaysShow = false) {
        if (!element)
            return;
        if (!element.parentElement)
            return;
        if (Math.round(timer) > 0) {
            element.parentElement.style.display = "flex";
        }
        else {
            if (!alwaysShow) {
                element.parentElement.style.display = "none";
            }
        }
    }
    updateDigits(digitElement, value) {
        if (!digitElement)
            return;
        // Adding the zeros.
        const zeroPad = (num, places) => String(num).padStart(places, "0");
        let values = zeroPad(value, 2).split("");
        // Prevent number starting with 0
        if (values[0] === "0") {
            values[0] = "";
        }
        let html = "";
        for (var i = 0; i < values.length; i++) {
            html += `<digit>${values[i]}</digit>`;
        }
        html = (html === "") ? "<digit>0</digit><digit>0</digit>" : html;
        html = "<digits>" + html + "</digits>";
        let htmlDoc = new DOMParser().parseFromString(html, "text/xml");
        let htmlEl = htmlDoc.firstElementChild ? htmlDoc.firstElementChild : null;
        if (!htmlEl)
            return;
        if (!htmlEl.firstChild)
            return;
        if (digitElement.querySelector("digits")) {
            // replace current digits
            if (digitElement) { }
            digitElement.querySelector('digits').innerHTML = htmlEl.innerHTML;
        }
        else {
            // append digits
            digitElement.appendChild(htmlEl);
        }
    }
    formatDigits(value) {
        // Adding the zeros.
        const zeroPad = (num, places) => String(num).padStart(places, "0");
        let values = zeroPad(value, 2).split("");
        let html = "";
        for (var i = 0; i < values.length; i++) {
            html += `<digit>${values[i]}</digit>`;
        }
        return html;
    }
  }
  


customElements.define('pdp-countdown-timer', PDPCountdownTimer);
